import { Server, Shield, Globe, Zap } from "lucide-react";

export function HostingHighlight({ t }) {
    const features = [
        { icon: Shield, label: t("billing.faq.hostingFeatures.ssl") },
        { icon: Globe, label: t("billing.faq.hostingFeatures.cdn") },
        { icon: Zap, label: t("billing.faq.hostingFeatures.uptime") },
    ];

    return (
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-600 via-indigo-700 to-violet-700 p-8 text-white">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3" />
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/4" />

            <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6">
                <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center">
                    <Server className="w-7 h-7 text-white" />
                </div>

                <div className="flex-1 space-y-3">
                    <div className="flex items-center gap-3">
                        <h3 className="text-xl font-bold">
                            {t("billing.faq.hostingHighlight.title")}
                        </h3>
                        <span className="text-xs font-semibold bg-white/20 px-2.5 py-1 rounded-full backdrop-blur-sm">
                            {t("billing.faq.hostingHighlight.badge")}
                        </span>
                    </div>
                    <p className="text-indigo-100 text-sm leading-relaxed max-w-xl">
                        {t("billing.faq.hostingHighlight.description")}
                    </p>
                    <div className="flex flex-wrap gap-4 pt-1">
                        {features.map(({ icon: FeatureIcon, label }) => (
                            <div key={label} className="flex items-center gap-2 text-sm text-indigo-100">
                                <FeatureIcon className="w-4 h-4 text-indigo-200" />
                                <span>{label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
